<ng-container *transloco="let t">
  <ld-base-modal [title]="t('modalsPaymentPortalConfirmationTitle')" (closeModal)="onClose()">
    <div modal-content>
      <div class="flex flex-col items-center justify-center py-8">
        <mat-icon id="payment-portal-confirmation-icon" class="text-green-600 text-5xl! w-12! h-12! mb-4">
          check_circle
        </mat-icon>
        <h3 id="payment-portal-confirmation-heading" class="font-dm text-xl font-semibold text-ld-neutral mb-2">
          {{ t('modalsPaymentPortalConfirmationHeading') }}
        </h3>
        <p id="payment-portal-confirmation-message" class="font-dm text-sm text-ld-neutral-500 text-center mb-6">
          {{ t('modalsPaymentPortalConfirmationMessage') }}
        </p>

        <div id="payment-portal-confirmation-details" class="w-full max-w-sm space-y-3">
          @if (data().confirmationNumber) {
            <div class="flex justify-between py-2 border-b border-ld-border">
              <span id="payment-portal-confirmation-number-label" class="font-dm text-sm text-ld-neutral-500">
                {{ t('modalsPaymentPortalConfirmationNumber') }}
              </span>
              <span id="payment-portal-confirmation-number-value" class="font-dm text-sm font-medium text-ld-neutral">
                {{ data().confirmationNumber }}
              </span>
            </div>
          }
          @if (data().amount !== null) {
            <div class="flex justify-between py-2 border-b border-ld-border">
              <span id="payment-portal-confirmation-amount-label" class="font-dm text-sm text-ld-neutral-500">
                {{ t('modalsPaymentPortalConfirmationAmount') }}
              </span>
              <span id="payment-portal-confirmation-amount-value" class="font-dm text-sm font-medium text-ld-neutral">
                {{ data().amount | currency }}
              </span>
            </div>
          }
          <div class="flex justify-between py-2 border-b border-ld-border">
            <span id="payment-portal-confirmation-date-label" class="font-dm text-sm text-ld-neutral-500">
              {{ t('modalsPaymentPortalConfirmationDate') }}
            </span>
            <span id="payment-portal-confirmation-date-value" class="font-dm text-sm font-medium text-ld-neutral">
              {{ data().paymentDate | date: 'MM/dd/yyyy' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div modal-footer>
      <button id="payment-portal-confirmation-close-btn" type="button" class="btn-solid-purple" (click)="onClose()">
        {{ t('commonAriaClose') }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
